// Report limits — docs/plans/2026-10-02-rapporten-ontwerp.md §3 (grenzen),
// §4 (signed asset URLs) and §5 (bridge). One place, so API, worker, web and
// the Goblic-MCP agree.

/** Max HTML per version (UTF-8 bytes). */
export const REPORT_MAX_HTML_BYTES = 1024 * 1024

/** Max size of one attachment (bytes). */
export const REPORT_MAX_ASSET_BYTES = 5 * 1024 * 1024

/** Max size of all attachments of one report together (bytes, deduplicated rows). */
export const REPORT_MAX_TOTAL_ASSET_BYTES = 50 * 1024 * 1024

/** Max versions per report; the next write is refused with `REPORT_LIMIT`. */
export const REPORT_MAX_VERSIONS = 100

/** `report_write` calls per run. */
export const REPORT_MAX_WRITES_PER_RUN = 20

/** `report_attach` calls per run. */
export const REPORT_MAX_ATTACHES_PER_RUN = 30

/** Max serialized size of one form submission (`JSON.stringify`, UTF-8 bytes). */
export const REPORT_MAX_SUBMISSION_BYTES = 64 * 1024

/** Submissions per report per minute (all users together). */
export const REPORT_SUBMISSIONS_PER_MINUTE = 20

/** Submissions per user per minute (over all reports). */
export const REPORT_SUBMISSIONS_PER_USER_PER_MINUTE = 5

/** Submissions one report keeps at most; the next one is refused with `REPORT_LIMIT`. */
export const REPORT_MAX_SUBMISSIONS_PER_REPORT = 500

/** `report_read` returns at most this many submissions per call (oldest first; the rest on the next call). */
export const REPORT_AGENT_READ_MAX_SUBMISSIONS = 50

/** …and at most this many bytes of submission JSON per call (at least one submission is always returned). */
export const REPORT_AGENT_READ_MAX_SUBMISSION_BYTES = 256 * 1024

/** Max size of one exported HTML file (attachments inlined as data: URIs, report escaped into `srcdoc`). */
export const REPORT_MAX_EXPORT_BYTES = 30 * 1024 * 1024

/** Exports one API process builds at the same time; more get 429. */
export const REPORT_MAX_CONCURRENT_EXPORTS = 2

/** Max asset name length (characters, extension included). */
export const REPORT_ASSET_NAME_MAX_LENGTH = 100

/** Max title length (characters). */
export const REPORT_TITLE_MAX_LENGTH = 200

/** Max summary length (characters). */
export const REPORT_SUMMARY_MAX_LENGTH = 1000

/** Max version message length (characters). */
export const REPORT_MESSAGE_MAX_LENGTH = 500

/** Signed asset URLs are valid this long (seconds). */
export const REPORT_ASSET_URL_TTL_SECONDS = 60 * 60

/**
 * Base64 body ceiling for the asset upload routes: 5 MB of bytes is ~6.7 MB
 * of base64, plus the JSON around it.
 */
export const REPORT_ASSET_UPLOAD_BODY_LIMIT_BYTES = 7 * 1024 * 1024

/** Embed prefix agents use in HTML/CSS: `assets/<name>` (or `./assets/<name>`). */
export const REPORT_ASSET_EMBED_PREFIX = 'assets/'

/** UTF-8 byte length without Node's Buffer (browser-safe). */
export function reportByteLength(text: string): number {
  return new TextEncoder().encode(text).length
}
